module.exports = __webpack_public_path__ + "img/certificate.fdb7f0e8.png";